"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useEffect, useState } from "react";
import { ENTERPRISE_TENANTS } from "@/config/enterprise-tenants";
import { PublicEnterpriseTenant } from "@/types/enterprise-tenant";
const EnterpriseContext = createContext<PublicEnterpriseTenant | null>(null);
export function EnterpriseProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [enterprise, setEnterprise] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const hostname = window.location.hostname;
      const tenant = hostname === "localhost" ? ENTERPRISE_TENANTS["decodahealth.com"] : Object.entries(ENTERPRISE_TENANTS).find(t3 => {
        const [domain] = t3;
        return hostname.endsWith(domain);
      })?.[1] || ENTERPRISE_TENANTS["decodahealth.com"];
      setEnterprise(tenant);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!enterprise) {
    return null;
  }
  let t3;
  if ($[2] !== children || $[3] !== enterprise) {
    t3 = <EnterpriseContext.Provider value={enterprise}>{children}</EnterpriseContext.Provider>;
    $[2] = children;
    $[3] = enterprise;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export function useEnterprise() {
  const context = useContext(EnterpriseContext);
  if (context === undefined) {
    throw new Error("useEnterprise must be used within an EnterpriseProvider");
  }
  return context;
}
export default EnterpriseProvider;